import { MonacoEditor } from "../../core/components/monacoEditor"
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { TextBox } from "../../core/components/textBox";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Grid } from "../../core/components/grid";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import { Config } from "../../core/config/config";
import { Parameter, EmailHelper } from "../emailHelper";
import { EmailDataSourceEntity } from "./dataSource";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class DataSourceEditor extends React.Component<DataSourceEditorProps, DataSourceEditorState>{
    private parameterListRef: ParameterList;
    constructor(props: DataSourceEditorProps) {
        super(props);
        this.state = {
            value: props.entity.Content,
            parameters: [],
            infoElement: null
        }
        this.setEvents();
    }

    private setEvents = () => {
        General.Sheet.Manager.getTopMostVisibleSheet().bind(SheetEventType.Custom, (data) => {
            if (Helper.hasValue(data)) {
                switch (data.cmd) {
                    case "executeSQL":
                        this.executeSQL();
                        break;
                }
            }
        })
    }

    private executeSQL = async () => {
        const params = await Promise.all(this.state.parameters.map((param) => { return this.getParamterValue(param.name) }));
        if (params.filter(f => !Helper.hasValue(f)).length == 0) {
            const sql = this.state.value;
            let parameterList = {};
            params.forEach((p) => { parameterList[p.Key] = p.Value })
            const result = await HTTPService.post<JsonResultClass<{}[]>>("EmailSender/ExecuteDataSource", { sql: sql, parameters: parameterList });
            let element: JSX.Element = null;
            switch (result.Code) {
                case 0:
                    if (result.Data.length > 0) {
                        element = EditorHelper.createGrid(result.Data);
                    }
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    //element = <div style={{ height: "100%" }}><label>{result.Message}</label></div>
                    break;
                case 2:
                    NotificationHelper.showWarningMessage(result.Message);
                    break;
            }
            this.setState({ infoElement: element });
        }
    }

    private getParamterValue = (name: string): Promise<KeyValuePair<string, string | number>> => {
        return new Promise<KeyValuePair<string, any>>(async (resolve) => {
            let result = this.state.parameters.find(f => f.name == name);
            if (EditorHelper.isValueEmpty(result.value)) {
                resolve({ Key: EmailHelper.getName(name), Value: result.value as any });
            } else {
                const dialogResult = await DialogHelper.prompt(EmailHelper.getName(name));
                if (Helper.hasValue(dialogResult)) {
                    resolve({ Key: EmailHelper.getName(name), Value: dialogResult as any });
                } else {
                    resolve(null);
                }
            }
        })
    }

    private setValue = (value: string, isInit: boolean = false) => {
        if (Helper.hasValue(this.parameterListRef)) {
            setTimeout(() => { this.parameterListRef?.checkParameters() }, 2500)
        }


        const parameters: Parameter[] = EmailHelper.getParameters(value).map((value) => {
            const p = this.state.parameters.find(f => f.name == value.name);
            if (Helper.hasValue(p))
                return p;
            else
                return value;
        })


        this.setState({ value: value, parameters: this.distinct(parameters) }, () => {
            if (!isInit) {
                this.props.onChange({ model: "entity.Content" }, value);
            }
        })
    }

    private distinct = (parameters: Parameter[]): Parameter[] => {
        let result: Parameter[] = [];
        for (let i = 0; i < parameters.length; i++) {
            let p = result.find(f => f.name == parameters[i].name);
            if (!Helper.hasValue(p)) {
                result.push(parameters[i]);
            }
        }
        return result;
    }

    private onParametersChange = (parameters: Parameter[]) => {
        this.setState({ parameters: parameters })
    }

    componentDidUpdate(prevProps: DataSourceEditorProps) {
        //dirty
        //später evtl. anpassen
        if (this.parameterListRef.state.type != this.props.entity.Type) {
            this.parameterListRef.setType(this.props.entity.Type);
        }
    }

    componentDidMount() {
        this.setValue(this.props.entity.Content, true);
    }

    render() {
        let dashBoardStyle: React.CSSProperties = { left: "0px", overflow: "hidden" };
        let rightSidebarStyle: React.CSSProperties = {};
        let editorContainerStyle: React.CSSProperties = {};
        let infoContainerStyle: React.CSSProperties = {};
        if (this.state.parameters.length == 0) {
            dashBoardStyle.width = "99%";
            rightSidebarStyle.width = "0%";
        }

        if (Helper.hasValue(this.state.infoElement)) {
            editorContainerStyle.height = "55%";
            infoContainerStyle.height = "45%";
        } else {
            editorContainerStyle.height = "100%";
            infoContainerStyle.height = "0%";
        }
        return (
            <>
                <div className="dashboardContent" style={dashBoardStyle}>
                    <div style={editorContainerStyle}>
                        <MonacoEditor language="sql" code={this.state.value} onKeyPress={this.setValue} />
                    </div>
                    <div style={infoContainerStyle}>
                        {this.state.infoElement}
                    </div>
                </div>
                <div className="rightSidebar" style={rightSidebarStyle}>
                    <ParameterList parameters={this.state.parameters} onChange={this.onParametersChange} type={this.props.entity.Type} ref={(ref) => { this.parameterListRef = ref }} />
                </div>
            </>
        );
    }
}

export interface DataSourceEditorProps {
    entity: EmailDataSourceEntity;
    onChange: (field, value) => void;
}

interface DataSourceEditorState {
    value: string;
    parameters: Parameter[];
    infoElement: JSX.Element;
}

class ParameterList extends React.Component<ParameterListProps, ParameterListState>{
    private parameters: {};
    private warningWasDisplayed: boolean;
    private translations: StringKeyDictionary<string>
    constructor(props: ParameterListProps) {
        super(props);
        this.state = {
            type: props.type,
            possibleParameters: null
        }
        this.parameters = null;
        this.warningWasDisplayed = false;
        this.initApp();
    }

    public setType = (type: number) => {
        if (Helper.hasValue(this.parameters))
            this.setState({ possibleParameters: this.parameters[type], type: type })
    }

    public checkParameters = () => {
        this.props.parameters.map((param) => {
            const p = this.state.possibleParameters.find(f => f.Name.toLowerCase() == EmailHelper.getName(param.name));
            if (!Helper.hasValue(p)) {
                this.showWarningMessage();
            }
        })
    }

    private initApp = async () => {
        let results = await Promise.all([EmailHelper.loadPossibleParameters(), this.loadTranlstaions()]);
        this.parameters = results[0];
        this.translations = results[1];
        this.setType(this.props.type);
    }

    private loadTranlstaions = (): Promise<StringKeyDictionary<string>> => {
        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            const key = "email_dataSource_editor_translations_" + Config.user.languageId;
            let result = Helper.loadDataFromStorage(key);
            if (Helper.hasValue(result)) {
                resolve(result);
            } else {
                const result = await Helper.getTranslations(["WebCRM.Email.UnsupportedParametersDetected"]);
                if (result.Code == 0) {
                    Helper.saveDataToStorage(key, result.Data, false);
                    resolve(result.Data)
                }
            }
        });
    }

    private onChange = (parameter: Parameter) => {
        let parameters = this.props.parameters;
        const index = parameters.findIndex(f => f.name == parameter.name);
        parameters[index] = parameter;
        this.props.onChange(parameters);
    }

    private showWarningMessage = () => {
        if (!this.warningWasDisplayed) {
            NotificationHelper.showWarningMessage(this.translations["WebCRM.Email.UnsupportedParametersDetected"]);
            this.warningWasDisplayed = true;
        }
    }

    componentDidUpdate() {
        if (Helper.hasValue(this.state.possibleParameters)) {
            let count = this.props.parameters.filter(param => this.state.possibleParameters.find(f => f.Name == EmailHelper.getName(param.name))).length
            if (count != 0) {
                this.warningWasDisplayed = false;
            }
        }
    }

    render() {
        if (Helper.hasValue(this.state.possibleParameters)) {
            return (
                <div style={{ margin: "2.5px" }}>
                    {
                        this.props.parameters.map((param) => {
                            const p = this.state.possibleParameters.find(f => f.Name == EmailHelper.getName(param.name));
                            return (
                                <React.Fragment key={kendo.guid()}>
                                    <ParameterBox
                                        name={param.name}
                                        value={param.value}
                                        onChange={this.onChange}
                                        isSupported={Helper.hasValue(p)}
                                        type={Helper.hasValue(p) ? p.TypeKind : 2} />
                                </React.Fragment>
                            );
                        })
                    }
                </div>
            );
        } else {
            return null;
        }
    }
}

interface ParameterListProps {
    type: number;
    parameters: Parameter[];
    onChange: (parameters: Parameter[]) => void
}

interface ParameterListState {
    type: number;
    possibleParameters: { Name: string, TypeKind: number }[];
}

class ParameterBox extends React.Component<ParameterBoxProps, ParameterBoxState>{
    private factory = ComponentHelper.createFactory();
    //private dtIntegral = 0;
    private dtFloatingPoint = 1;
    private dtString = 2;
    constructor(props: ParameterBoxProps) {
        super(props);
        this.state = {
            value: props.value
        }
    }

    private setValue = (value: string | number) => {
        this.setState({ value: value }, () => {
            this.props.onChange({ name: this.props.name, value: this.state.value });
        })
    }

    private createTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.value, "");
        props.onChange = (_, value) => {
            this.setValue(value);
        }
        return <><TextBox {...props} /></>
    }

    private createNumericBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.value;//Helper.getValueOrDefault(this.state.value, 0);
        props.field.decimals = this.props.type == this.dtFloatingPoint ? 1 : 0;
        props.onChange = (_, value) => {
            this.setValue(value);
        }
        return <><IsNumericTextBox {...props} /></>
    }

    private createBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.value, "");
        props.onChange = (_, value) => {
            this.setValue(value);
        }
        return (
            <div style={{ backgroundColor: this.props.isSupported ? null : "#ffd54f" }}>
                <FieldInstance label={EmailHelper.getName(this.props.name)}>
                    {this.props.type == this.dtString ? this.createTextBox() : this.createNumericBox()}
                </FieldInstance>
            </div>
        );
    }

    render() {
        return (
            <>
                {this.createBox()}
            </>
        );
    }
}

interface ParameterBoxProps extends Parameter {
    onChange: (parameter: Parameter) => void;
    type: number;
    isSupported: boolean;
}

interface ParameterBoxState {
    value: string | number;
}

class EditorHelper {
    public static isValueEmpty = (value: string | number) => {
        switch (typeof value) {
            case "number":
                return Helper.hasValue(value) && Helper.isNumber(value);
            case "string":
                return Helper.hasValue(value) && !Helper.isNullOrEmpty((value || "").toString());
            default:
                return false;
        }
    }


    public static createGrid = (data: {}[]) => {
        const maxRows = 100;
        const maxColumns = 100;
        let showMSG = false;

        let gridData = data.map((obj) => {
            let r = {};
            Object.keys(obj).forEach((key, index) => {
                if (Helper.isNullOrEmpty(key)) {
                    r[`Column ${index + 1}`] = obj[key];
                } else {
                    r[key] = obj[key];
                }
            })
            return r;
        }).filter((_, index) => { showMSG = showMSG || !(index < maxRows); return index < maxRows; })


        const columns: kendo.ui.GridColumn[] = Object.keys(gridData[0]).filter((_, index) => { showMSG = showMSG || !(index < maxColumns); return index < maxColumns; }).map((value) => {
            return {
                field: value,
                title: value,
                width: "150px"
            }
        });
        if (showMSG)
            NotificationHelper.showInfoMessage("Es können nicht alle Daten angezeigt werden")
        const options: kendo.ui.GridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: columns
        }

        return (
            <div style={{ height: "100%" }}>
                <Grid
                    data={gridData}
                    options={options}
                    id="dataSourceEditorGrid"
                />
            </div>
        );
    }
}